import { buildTextareaInput } from "./buildTextareaInput";
import { delegateEvent } from "~/foundation/Events/events";
import { toggleClass, hasClass } from "~/foundation/Dom/classList";

export const createMarkup = (option, field, errorMessageTargetClass, additional) => {
	const selectedValues = field.selectedValues?.toLowerCase().split(",");

	return `
        <li>
            <label>
                <input type="checkbox"
                    name="${additional ? "additional." : ""}${field.key}"
                    value="${option.value}"
                    data-error-message="${field.defaultErrorMessage}"
                    data-error-container="${errorMessageTargetClass}"
                    ${
											selectedValues?.includes(option.value.toLowerCase())
												? ` checked`
												: ``
										}
                    ${field.readOnly ? ` readonly` : ``}
                    ${field.isRequired ? ` required` : ``}
                     ${
	option.textArea
		? `class="volunteer-signup__textarea-trigger"`
		: ``
}
                />
                <span>${option.label}</span>
                <div class="volunteer-signup__checkmark">
									<svg width="18" height="12" viewBox="0 0 18 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
											<path d="M17.3035 0.694036L6.69141 11.3061" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
											<path d="M6.69251 11.3025L1.30469 5.91467" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
									</svg>
								</div>
            </label>
        </li>
        ${
	option.textArea
		? `
                    <li class="volunteer-signup__textarea-group volunteer-signup__textarea-group--checkbox">
                        ${buildTextareaInput(option.textArea)}
                    </li>
                `
		: ""
}
    `;
};

export const buildCheckboxInput = (field, errorMessageTargetClass,additional = false) => {
	let textAreaOpen = false;

	// eslint-disable-next-line no-unused-vars
	delegateEvent(".volunteer-signup__textarea-trigger", "click", e => {
		const currentTextArea = document.querySelector(
			".volunteer-signup__step:not([hidden]) .volunteer-signup__textarea-group--checkbox"
		);

		textAreaOpen = hasClass(currentTextArea, "open-field");

		toggleClass(currentTextArea, "open-field", !textAreaOpen);

		textAreaOpen = !textAreaOpen;
	});

	return field.options
		.map(option => createMarkup(option, field, errorMessageTargetClass, additional))
		.join("");
};
